
  import { Vue } from 'vue-class-component';
  import { useRouter, useRoute } from 'vue-router'
  import { RestService } from "../service/rest.service";
  import { Watch } from "vue-property-decorator";

  export default class ResourceDetailView extends Vue {

    router = useRouter()
    route = useRoute()

    restService = new RestService('resources')

    id: string = this.route.params.id as string
    item: any = null
    others: any = []

    mounted() {
      this.fetchData(this.id)
    }

    @Watch('route.params.id')
    fetchData(id: string) {
      this.restService.get(id)
          .then((data) => this.item = data)
          .catch(() => this.router.push('/404'))

      this.restService.getsBy('/' + id + '/other')
          .then((data) => this.others = data)
          .catch((e) => console.log(e))
    }
  }
